// import deliveryInfo from "./product-specs/DeliveryInfo.vue";
// import offlineWarning from "./product-specs/OfflineWarning.vue";
// import shopProductOptions from "./product-specs/shop-product-options.vue";
// import * as bidding from "./bidding";
// import subButton from "./subscribe-button/sub-button.vue";

import { h, createApp } from "vue";
import labels from "../shared/labels";
import { mountReplace } from "../../../utilities/mount-replace";

export default {
    // specs: {
    //     deliveryInfo,
    //     offlineWarning,
    //     shopProductOptions,
    // },
    // bidding,
    // subButton,
    async inactiveProductPopup(
        el: string | HTMLElement,
        mode: string,
        links: { link: string; text: string }[]
    ) {
        return await this.basicPopup(
            el,
            labels.frontendProductpage.inactiveProductPopup.mainText[mode],
            links,
            "inactive-product-popup-container"
        );
    },
    async basicPopup(
        el: string | HTMLElement,
        message: string,
        links: { link: string; text: string }[],
        compName: string | undefined = undefined
    ) {
        const inactiveProductPopup = (await import("./basic-popup.vue"))
            .default;
        const Vue = (
            await import(
                /* webpackFetchPriority: "high" */
                "vue"
            )
        ).default;
        const comp = createApp({
            name: compName ?? "basic-popup-container",
            render: function () {
                return h(inactiveProductPopup, {
                    message: message,
                    links: links,
                });
            },
        });
        mountReplace(comp, el);
        return comp;
    },
};
